import { render, staticRenderFns } from "./DynamicCommentList.vue?vue&type=template&id=a2ce6dfc&scoped=true"
import script from "./DynamicCommentList.vue?vue&type=script&lang=js"
export * from "./DynamicCommentList.vue?vue&type=script&lang=js"
import style0 from "./DynamicCommentList.vue?vue&type=style&index=0&id=a2ce6dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ce6dfc",
  null
  
)

export default component.exports